import React from "react"
import { ContextProvider } from "../../layouts/Context"
import Consumer from "../../layouts/Context"
// import "./ArticleFooter.scss"

// Components
import KarmaPoll from "../KarmaPoll/KarmaPoll"

class ArticleFooter extends React.Component {

  render() {

    return (
      <ContextProvider>
        <div className="article__footer" tabIndex="0">
          <Consumer>
            {context =>
              <>
                <KarmaPoll context={context} fixed={this.props.fixed} />
              </>
            }
          </Consumer>
        </div>
      </ContextProvider>
    )
  }
}

export default ArticleFooter